import React from 'react'
import under from '../../assets/under.svg'
import avatar from '../../assets/avatar.png'
import avatar2 from '../../assets/PPv2.png'
import avatar3 from '../../assets/avatar2.avif'


function TeamSection() {
    return (
        <div className='pt-20'>
            <div className='max-w-[80rem] px-8 mx-auto flex flex-col items-center justify-center'>
                <div className="mx-auto text-center">
                    <h1 className="mt-5 text-3xl text-center font-bold text-gray-800 sm:text-5xl lg:text-6xl">
                        Our {""}
                        <span className="relative inline-block">
                            <span className="absolute inset-0  bg-primary transform -rotate-2 z-0"></span>
                            <span className="relative z-10 font-bold px-2 py-1 text-second">
                                Team
                            </span>
                            <img src={under} alt="err" className='absolute' />
                        </span>
                    </h1>
                    <h1 className='text-gray-600 pt-8 text-center max-w-4xl'>We’re a passionate group of innovators and problem-solvers, united by a shared mission to build impactful solutions. Each team member brings unique expertise, working together to shape the future and deliver real value.</h1>
                </div>

                <div className="max-w-5xl w-full px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-8 md:gap-12">

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar2} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Athar Raza
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Co Founder / CEO <br /> Full Stack Developer
                                </p>
                            </div>
                        </div>

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Aftab Ahmad
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Co Founder / CEO <br /> Full Stack Developer
                                </p>
                            </div>
                        </div>

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Numan Ali
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Co Founder / CEO <br /> MERN Stack Developer
                                </p>
                            </div>
                        </div>

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Ayaan Ali
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Cheif Financial Officer <br /> (CFO)
                                </p>
                            </div>
                        </div>

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Mustafa Khan
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Business Development Manager
                                </p>
                            </div>
                        </div>

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Mohammad Abdullah
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Chief Marketing Officer  <br /> (CMO)
                                </p>
                            </div>
                        </div>

                        <div className="text-center">
                            <img className="rounded-full size-24 mx-auto" src={avatar3} alt="Avatar" />
                            <div className="mt-2 sm:mt-4">
                                <h3 className="font-medium text-gray-800">
                                    Amna Dilber
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Data Analyst
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default TeamSection
